import { render, staticRenderFns } from "./CategoryQuickView.vue?vue&type=template&id=2e6f58d4&scoped=true"
import script from "./CategoryQuickView.vue?vue&type=script&lang=js"
export * from "./CategoryQuickView.vue?vue&type=script&lang=js"
import style0 from "./CategoryQuickView.vue?vue&type=style&index=0&id=2e6f58d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6f58d4",
  null
  
)

export default component.exports